import axios from 'axios';

const removeCredit = async (videoId) => {
    try {
        const token = localStorage.getItem('token'); // Substituindo AsyncStorage por localStorage
        if (!token) {
            return {
                success: false,
                error: 'Usuário não autenticado.'
            };
        }

        const response = await axios.post(
            'https://apem.riderup.uk/api/removeCredit',
            { videoId },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );

        if (response.status === 200) {
            return {
                success: true,
                message: response.data.message
            };
        } else {
            return {
                success: false,
                error: response.data.message || 'Erro ao remover créditos.'
            };
        }
    } catch (error) {
        console.error('Erro ao remover créditos:', error);
        return {
            success: false,
            error: error.response?.data?.message || 'Erro ao conectar com a API.'
        };
    }
};

export default removeCredit;
